import React, { useEffect } from "react";
import { apiGet, apiPostPut } from "../../api/api_methods";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../../api/authApi";
import { setGlobalNavigate } from "../../api/httpClient";

export default function AutoLogin() {
  const { UserStore } = useStores();
  const navigate = useNavigate();
  useEffect(() => {
    // Wire global navigate handler for httpClient logout redirects
    setGlobalNavigate(() => {
      navigate("/login");
    });

    const params = new URLSearchParams(window.location.search);
    const userId = params.get("recruiterId");

    const syncCurrentUser = async () => {
      try {
        const meRes = await getCurrentUser();
        if (meRes?.success && meRes?.data) {
          const user = meRes.data;
          if (UserStore?.setUserDetails) {
            UserStore.setUserDetails(user);
          }
        }
      } catch (e) {
        // ignore; likely not logged in or session invalid
      }
    };

    const run = async () => {
      // Get user data from MobX store
      const parsedUser = UserStore.userDetails;
      const isAccountVerified = parsedUser?.isAccountVerified;
      console.log("AutoLogin Debug:", {
        userId,
        isAccountVerified,
        hasUserData: !!parsedUser?._id,
        currentPath: window.location.pathname,
      }); // If no userId or account not verified, navigate to AccountVerification
      if (!userId && parsedUser?._id && !isAccountVerified) {
        console.log(
          "Navigating to AccountVerification - userId:",
          userId,
          "isAccountVerified:",
          isAccountVerified,
        );
        navigate("/AccountVerification");
        return;
      }
      if (!userId) return;
      try {
        const response = await apiPostPut(
          null,
          `/user/user-with-id/${userId}`,
          "PUT",
        );
        if (response.status === 200 && response?.body?.data) {
          const user = response.body.data;
          if (UserStore?.setUserDetails) {
            UserStore.setUserDetails(user);
          }
          //   const url = window.location.href;
          //   const newUrl = url.replace("recruiterId", "userId");
          //   window.history.replaceState(null, "", newUrl);
          //   window.location.reload();
        }
      } catch (e) {
      } finally {
        // Clean the userId from the URL without reloading the page
        try {
          if (!UserStore.userDetails?.isAccountVerified) {
            // setIsAccountVerified(true);
            navigate("/AccountVerification");
          }
          const newParams = new URLSearchParams(window.location.search);
          newParams.delete("recruiterId");
          const newQuery = newParams.toString();
          const newUrl = `${window.location.pathname}${
            newQuery ? `?${newQuery}` : ""
          }${window.location.hash}`;
          window.history.replaceState(null, "", newUrl);
          window.location.reload();
        } catch (_) {}
      }
    };

    if (!userId) {
      syncCurrentUser();
    }

    run();
  }, [UserStore]);

  return null;
}
